import { useLocation } from 'react-router-dom';

export const useQuery = () => new URLSearchParams(useLocation().search);

export const useQueryName = (name) => new URLSearchParams(useLocation()[name]);
